import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { getServerUrl } from '../shared/utils/utils';
import { ErrorStateMatcher } from '@angular/material/core';
import {
  FormControl,
  FormGroupDirective,
  NgForm,
  Validators,
  ValidatorFn,
  AbstractControl
} from '@angular/forms';

/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: FormControl | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    const isSubmitted = form && form.submitted;
    return !!(
      control &&
      control.invalid &&
      (control.dirty || control.touched || isSubmitted)
    );
  }
}

@Component({
  selector: 'pbg-page-login',
  templateUrl: './page-login.component.html',
  styleUrls: ['./page-login.component.scss']
})
export class PageLoginComponent implements OnInit {
  @Output()
  login = new EventEmitter();
  name = '';
  gameId = '';
  gameExistsError = false;
  matcher = new MyErrorStateMatcher();
  roomCodeFormControl = new FormControl('', [
    Validators.required,
    this.roomCodeIsValid()
  ]);

  constructor(
    private cookieService: CookieService,
    private router: Router,
    public httpClient: HttpClient
  ) {}

  ngOnInit() {}

  submit() {
    this.cookieService.deleteAll('/host');
    this.cookieService.deleteAll('/');
    this.cookieService.deleteAll();

    this.gameId = this.gameId.toUpperCase();
    const serverUrl = getServerUrl(this.gameId);
    const url = `${serverUrl}/client-login`;

    console.log(serverUrl);

    const body = {
      gameId: this.gameId
    };

    this.httpClient.request('post', url, { body }).subscribe(
      (resp: any) => {
        if (resp.success) {
          this.cookieService.set('username', this.name, 1, '/');
          this.cookieService.set('gameId', this.gameId, 1, '/');
          this.cookieService.set('userId', this.getRandomId(), 1, '/');
          this.router.navigate(['/' + resp.route]);
        } else {
          this.gameExistsError = true;
        }
      },
      error => {
        console.log(error);
        this.gameExistsError = true;
      }
    );
  }

  getRandomId(): string {
    return Math.floor(Math.random() * 1000000) + '';
  }

  roomCodeIsValid(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      return this.gameExistsError ? { roomCodeIsValid: { value: control.value } } : null;
    };
  }
}
